import { ReactNode } from 'react'
import styled from 'styled-components'

import { ExternalLink as ExternalLinkIcon } from '@/components/Icons'

const StyledExternalLinkIcon = styled(ExternalLinkIcon)`
  color: var(--wg-dark-blue);
  height: 1em;
`
const LinkContainer = styled.span`
  a {
    display: flex;
    align-items: center;
    gap: 5px;
  }
`

type ExternalLinkProps = {
  href?: string
  className?: string
  children: ReactNode
}

const ExternalLink = ({ href, children, className }: ExternalLinkProps) => {
  return (
    <LinkContainer className={className}>
      <a href={href} target="_blank" rel="noreferrer">
        {children}
        <StyledExternalLinkIcon />
      </a>
    </LinkContainer>
  )
}

export default ExternalLink
